module.exports = __webpack_public_path__ + "static/media/toolbar-zoom-out.02d247fc.svg";